import React from 'react';
import { FadeIn } from './FadeIn';
export function SpendingCycleDiagram() {
  const nodes = [{
    id: 1,
    label: 'Stress',
    desc: 'The Trigger'
  }, {
    id: 2,
    label: 'Scroll',
    desc: 'The Search'
  }, {
    id: 3,
    label: 'Purchase',
    desc: 'The Action'
  }, {
    id: 4,
    label: 'Relief',
    desc: 'The Reward'
  }, {
    id: 5,
    label: 'Regret',
    desc: 'The Aftermath'
  }];
  return <div className="my-10 md:my-20 py-6 md:py-12 px-4 bg-white/10 backdrop-blur-sm rounded-3xl border border-gold/20 shadow-sm max-w-4xl mx-auto" data-id="element-256">
      <div className="flex flex-col md:flex-row items-center justify-between relative gap-6 md:gap-4" data-id="element-257">
        {/* Desktop connecting line */}
        <div className="hidden md:block absolute top-1/2 left-[10%] right-[10%] h-0.5 bg-cream/20 -translate-y-1/2 z-0" data-id="element-258"></div>

        {/* Mobile connecting line */}
        <div className="md:hidden absolute left-1/2 top-[10%] bottom-[10%] w-0.5 bg-cream/20 -translate-x-1/2 z-0" data-id="element-259"></div>

        {nodes.map((node, index) => <FadeIn key={node.id} delay={index * 150} className="relative z-10 flex flex-col items-center group" data-id="element-260">
            <div className="w-16 h-16 md:w-28 md:h-28 rounded-full bg-cream border-2 border-gold flex items-center justify-center shadow-md transition-transform duration-500 hover:scale-105" data-id="element-261">
              <span className="font-serif text-navy font-semibold text-sm md:text-xl" data-id="element-262">
                {node.label}
              </span>
            </div>

            {/* Arrow for mobile (except last) */}
            {index < nodes.length - 1 && <div className="md:hidden h-6 w-0.5 bg-gold/40 my-1 relative" data-id="element-263">
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-2 h-2 border-b-2 border-r-2 border-gold/40 rotate-45" data-id="element-264"></div>
              </div>}

            {/* Arrow for desktop (except last) */}
            {index < nodes.length - 1 && <div className="hidden md:block absolute -right-6 top-1/2 -translate-y-1/2 w-4 h-4 border-t-2 border-r-2 border-gold/40 rotate-45" data-id="element-265"></div>}
          </FadeIn>)}
      </div>

      <FadeIn delay={1000} data-id="element-266">
        <p className="text-center mt-8 md:mt-12 text-cream/60 italic text-xs md:text-base" data-id="element-267">
          The subconscious loop that runs quietly in the background.
        </p>
      </FadeIn>
    </div>;
}